import { ChevronDown } from 'lucide-react';
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

import {
  SidebarMenuButton,
  SidebarMenuSub,
  SidebarMenuSubButton,
} from '@/components/ui/sidebar';
import { HOME_TOUR_CLASSES } from '@/constants/tour/classNames';
import { isLockedDiscovery } from '@/lib/discovery';
import { DiscoveryStatus } from '@/types/discovery.status.type';
import { Stage } from '@/types/stage.type';

interface DiscoverySubmenuProps {
  item: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    icon: React.ComponentType<any>;
    label: string;
    path: string;
  };
  stages: Stage[];
  discoveryStatus: DiscoveryStatus;
}

export const DiscoverySubmenu = ({
  item,
  stages,
  discoveryStatus,
}: DiscoverySubmenuProps) => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(true);

  const hasStages = stages?.length > 0;

  const handleToggle = () => {
    if (hasStages) {
      setIsOpen(!isOpen);
    }
  };

  return (
    <>
      <SidebarMenuButton
        onClick={handleToggle}
        isActive={!isOpen && location.pathname.includes(item.path)}
        disabled={!hasStages}
        className={`${HOME_TOUR_CLASSES.SIDEBAR_DISCOVERY_PARENT_BUTTON} flex items-center justify-between`}
      >
        <div className="flex items-center gap-3">
          <item.icon size={20} />
          {item.label}
        </div>
        {hasStages && (
          <ChevronDown
            className={`h-4 w-4 transition-transform duration-200 ${
              isOpen ? 'rotate-180' : ''
            }`}
          />
        )}
      </SidebarMenuButton>

      {hasStages && isOpen && (
        <SidebarMenuSub className="m-0 mt-3 border-none p-0">
          {stages.map((stage, index) => (
            <div key={stage.id}>
              {index > 0 && <div className="ml-[27px] h-3 w-[2px] bg-border" />}
              <SidebarMenuSubButton
                asChild
                isActive={location.pathname === `${item.path}/${stage.id}`}
                disabled={isLockedDiscovery(index, stages, discoveryStatus)}
                className={
                  index === 0
                    ? HOME_TOUR_CLASSES.SIDEBAR_DISCOVERY_STAGE_1_BUTTON
                    : `sidebar-discovery-stage-${index + 1}-button`
                }
              >
                <Link
                  to={`${item.path}/${stage.id}`}
                  className="flex h-auto items-center gap-3 rounded-xl px-4 py-2"
                >
                  <div className="as-title-04 as-strong flex size-6 flex-shrink-0 items-center justify-center rounded-full border bg-muted text-muted-foreground">
                    {index + 1}
                  </div>
                  <span>{stage.name}</span>
                </Link>
              </SidebarMenuSubButton>
            </div>
          ))}
        </SidebarMenuSub>
      )}
    </>
  );
};
